export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;
type UtmParamKey = typeof UTM_PARAMS[number];
export type UtmObject = Partial<Record<UtmParamKey, string | null>>;

export const captureUtms = (searchString?: string): void => {
  console.log("captureUtms function called");
  if (typeof window !== 'undefined') {
    console.log("window is defined in captureUtms");
    const currentSearch = searchString !== undefined ? searchString : window.location.search;
    const params = new URLSearchParams(currentSearch);
    console.log("URL Search Params in captureUtms:", currentSearch);
    console.log("Parsed Params object:", params.toString());

    UTM_PARAMS.forEach(param => {
      if (params.has(param)) {
        const value = params.get(param)!;
        localStorage.setItem(param, value);
        console.log(`Stored UTM in localStorage: ${param} = ${value}`);
      } else {
        // console.log(`UTM param ${param} not found in URL`); // Optional: uncomment for more verbose logging
      }
    });
  } else {
    console.log("window is NOT defined in captureUtms");
  }
};

export const getUtmsFromStorage = (): UtmObject => {
  const utms: UtmObject = {};
  if (typeof window !== 'undefined') {
    UTM_PARAMS.forEach(param => {
      const value = localStorage.getItem(param);
      if (value) {
        utms[param] = value;
      }
    });
  }
  return utms;
};

// Optional: if you want to clear them after a specific action, e.g., purchase recorded.
export const clearUtmsFromStorage = (): void => {
  if (typeof window !== 'undefined') {
    UTM_PARAMS.forEach(param => {
      localStorage.removeItem(param);
    });
  }
}; 